import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { DEVIATIONS_PER_FETCH } from '../constants';
import { getCommissionStreamId } from '../helpers';
function* handleInitCommissionStream() {
    const streamId = getCommissionStreamId();
    const isStreamInitialized = yield select(selectors.isInitialized, streamId);
    if (isStreamInitialized) {
        return;
    }
    yield all([
        put(withOffset.actions.initialize({
            streamId,
            itemsPerFetch: DEVIATIONS_PER_FETCH
        })),
        put(withOffset.actions.fetch(streamId))
    ]);
}
export default handleInitCommissionStream;
